import { Box, Button, CircularProgress, Grid, Link } from '@mui/material';
import { Ico_Plus, PageTitle } from '@sagecentral/core-ui';
import WorkItemDraftsDrawer from 'components/work-items/drafts/drawer/WorkItemDraftsDrawer';
import useAccountPermissions from 'hooks/accounts/useAccountPermissions';
import { useFeatureEnabled } from 'hooks/shared';
import { useState } from 'react';
import { Helmet } from 'react-helmet';

const CreateDashboard = () => {
    const [openDrafts, setOpenDrafts] = useState(false);
    const onHandleViewDrafts = () => setOpenDrafts(!openDrafts);
    const permissions = useAccountPermissions();
    const [ wave4Enabled ] = useFeatureEnabled('wave-4');
    const workitemCreateUrl = `/workitems/create`;    
    const workitemCreateUrlClassic = process.env.REACT_APP_CLASSIC_URL + `/WorkItemEnduser/CreateWorkItemInstance`;
    const workspaceCreateUrl = process.env.REACT_APP_CLASSIC_URL + `/WorkspaceEnduser/CreateWorkspaceEndUser?area=WorkflowEnduser`;
    return (
        <Box>
            <Helmet>
                <title>Sage Central | Create</title>
            </Helmet>
            <Box sx={{ display: "flex" }}>
                <PageTitle sx={{ color: '#001A69' }}>
                    Create
                </PageTitle>

            </Box>

            {permissions ? 
            <Box sx={{ display: 'grid', gap: '24px' }}>
                {permissions?.canCreateWorkItem &&
                    <>
                        {wave4Enabled  && 
                        <Grid container spacing={8}>
                            <Grid item >
                                <Button startIcon={<Ico_Plus />} variant="contained" sx={{ margin: '0px', width: '220px', height: '40px' }} href={workitemCreateUrl}>
                                    Create New Work Item 
                                </Button>

                            </Grid>
                            <Grid item sx={{alignContent: 'center'}}>
                                <Link sx={{ margin: '0px' }} onClick={onHandleViewDrafts}>
                                    View Work Item Drafts
                                </Link>

                            </Grid>
                        </Grid>
                        ||
                        <Box>
                            <Button startIcon={<Ico_Plus />} variant="contained" sx={{ margin: '0px', width: '220px', height: '40px' }} href={workitemCreateUrlClassic}>
                               Create New Work Item
                            </Button>

                        </Box>
                        }
                    </>
                }
                {permissions?.canCreateWorkspace &&
                    <Box>
                        <Button startIcon={<Ico_Plus />} variant="contained" sx={{ margin: '0px', width: '220px', height: '40px'}} href={workspaceCreateUrl}>
                           Create New Workspace
                        </Button>
                    </Box>
                }
            </Box>
            : <CircularProgress />}
            <WorkItemDraftsDrawer opener={openDrafts} onClose={() => setOpenDrafts(false)} />
        </Box>
    )
};

export default CreateDashboard;